// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"support-address_sectionContainer__awbid","textWrapper":"support-address_textWrapper__9MB8I"};